var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSurveyCategoryDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1058_4020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.25H20.25C20.66 11.25 21 11.59 21 12C21 12.41 20.66 12.75 20.25 12.75H3.75C3.34 12.75 3 12.41 3 12C3 11.59 3.34 11.25 3.75 11.25Z",
    fill: "#A0AEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6H20.25C20.66 6 21 6.34 21 6.75C21 7.16 20.66 7.5 20.25 7.5H3.75C3.34 7.5 3 7.16 3 6.75C3 6.34 3.34 6 3.75 6Z",
    fill: "#A0AEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.5H20.25C20.66 16.5 21 16.84 21 17.25C21 17.66 20.66 18 20.25 18H3.75C3.34 18 3 17.66 3 17.25C3 16.84 3.34 16.5 3.75 16.5Z",
    fill: "#A0AEC0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1058_4020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12,
    fill: "white",
    transform: "translate(3 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSurveyCategoryDark);
export default __webpack_public_path__ + "static/media/ico-survey-category-dark.c9a67dc1e192c2c917a32e72db858259.svg";
export { ForwardRef as ReactComponent };